// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"FormInput_inputContainer__2NFWU","input":"FormInput_input__38V0i"};